import { of } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { Injectable } from '@angular/core';
import * as actions from './actions';
import { AdditionalContentService } from '../../services/additional-content.service';
import { AlertService } from '../../services/alert.service';
import { switchMap, catchError, map } from 'rxjs/operators';
import {StatusHelper} from '../../helpers/statuses-helper';

@Injectable()
export class AdditionalContentEffects {
  constructor(
    protected store: Store<AppState>,
    protected service: AdditionalContentService,
    protected action$: Actions,
    private alertService: AlertService
  ) { }

  GetAdditionalContentEvents$ = createEffect(() => this.action$.pipe(
    ofType<actions.GetAdditionalContentEventsAction>(actions.GET_ADDITIONAL_CONTENT_EVENTS),
    switchMap(action => this.service.getAll(action.isPast, action.clubId).pipe(
      map((result) => new actions.GetAdditionalContentEventsSuccessAction(result)),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.GetAdditionalContentEventsErrorAction(error));
      })))));

  GetAdditionalContentEventById$ = createEffect(() => this.action$.pipe(
    ofType<actions.GetAdditionalContentEventByIdAction>(actions.GET_ADDITIONAL_CONTENT_EVENT_BY_ID),
    switchMap(action => this.service.getById(action.id, action.contentType).pipe(
      map((result) => new actions.GetAdditionalContentEventByIdSuccessAction(result)),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.GetAdditionalContentEventByIdErrorAction(error));
      })))));

  CreateAdditionalContentEvent$ = createEffect(() => this.action$.pipe(
    ofType<actions.CreateAdditionalContentEventAction>(actions.CREATE_ADDITIONAL_CONTENT_EVENT),
    switchMap(action => this.service.createEvent(action.payload).pipe(
      map((result) => {
        const message = `Content Session created, status: ${StatusHelper.getStatusText(result.status)}`;
        this.alertService.success(message);
        return new actions.CreateAdditionalContentEventSuccessAction(result);
      }),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.CreateAdditionalContentEventErrorAction(error));
      })))));

  UpdateAdditionalContentEvent$ = createEffect(() => this.action$.pipe(
    ofType<actions.UpdateAdditionalContentEventAction>(actions.UPDATE_ADDITIONAL_CONTENT_EVENT),
    switchMap(action => this.service.updateEvent(action.payload).pipe(
      map((result) => {
        const message = `Content Session updated, status: ${StatusHelper.getStatusText(result.status)}`;
        this.alertService.success(message);
        return new actions.UpdateAdditionalContentEventSuccessAction(result);
      }),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.UpdateAdditionalContentEventErrorAction(error));
      })))));
}
